import { configureStore } from '@reduxjs/toolkit';

import OverviewReducer from './reducers/OverviewReducer';

const store = configureStore({
  reducer: {
    overview: OverviewReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export type StoreDispatch = typeof store.dispatch;

export default store;